import { performGetRequest } from '@atlassian/jira-fetch';

const VISIBLITY_KEY = 'jsm-better-in-product-guidance.visibility';
const getProjectPropertiesApiUrl = (projectKeyOrId: string, propertyKey: string) =>
	`/rest/api/3/project/${projectKeyOrId}/properties/${propertyKey}`;

export const getProjectProperty = async (
	projectKeyOrId: string,
): Promise<{ key: string; value: string }> =>
	performGetRequest(getProjectPropertiesApiUrl(projectKeyOrId, VISIBLITY_KEY)).then((result) => {
		// performGetRequest returns null when endpoint returns no content
		if (result === null) {
			return {};
		}
		return result;
	});
